export default "/images/311ad4c928cceaec2162c1a9691c6b59.png";